// Approved route motion A: release and settle inside a stationary vessel.
export const TACTILE_SETTLE = Object.freeze({ exit: 90, enter: 240 });
const translated = (base, distance) => `${base && base !== 'none' ? base + ' ' : ''}translateY(${distance}px)`;
export const settleFrames = (phase, from = {}, base = 'none') => phase === 'exit'
  ? [{ opacity: from.opacity ?? 1, transform: from.transform ?? base }, { opacity: 0, transform: translated(base, 3) }]
  : [{ opacity: 0, transform: translated(base, -8) }, { opacity: 1, transform: base }];
export const settleOptions = phase => ({
  duration: TACTILE_SETTLE[phase],
  easing: phase === 'exit' ? 'ease-in' : 'cubic-bezier(.2,.8,.2,1)',
  ...(phase === 'exit' ? { fill: 'forwards' } : {}),
});
